import React, { Component } from 'react';
import{
    Container,
    Col,
    Row,
    Button,
    Table
} from 'reactstrap';
/**
 * Used for the Listino Prezzi section. 
 */
export class NuovoClienteMenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pendingClienti: [],
            nonApprovClienti: [],
            add: false,
        };
    
    }

    
    /**
     * Runs upon initial mount of the /listinoPrezzi path
     */
    componentDidMount(){
        
        if(sessionStorage.getItem("selectedRole") === "Agenti" || sessionStorage.getItem("selectedRole") === "Amministrazione"){
            const form = {
                Informazione: "",
                CurrentRole: this.props.role
            };
    
            fetch(`../api/clienti/cerca/pending_approv`, {   
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Sets the body of the call
                body: JSON.stringify(form)
                //Changes the response to an object
            }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    pendingClienti: myjson
                })
            }).catch(e => {
    
            });

            fetch(`../api/clienti/cerca/nonapprov`, {   
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Sets the body of the call
                body: JSON.stringify(form)
                //Changes the response to an object
            }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    nonApprovClienti: myjson
                })
    
            }).catch(e => {
    
            });
        }
        
    }    

    handleAddNewCliente = () => {
        this.props.history.push('/nuovoCliente/add')
    }

    handleDelete = (codiceCliente) => {
        fetch(`/api/clienti/delete/${codiceCliente}`, {   
            method: 'POST',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            this.setState({
                nonApprovClienti: myjson
            })
        }).catch(e => {

        });
    }
    /**
     * Renders the page
     */
    render() {

        const titolo = (
            <h5 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Nuovi Clienti</h5>
        );

        return (
            <Container fluid style={{minHeight: '75vh'}}> 
                <Container className="d-flex align-items-center" fluid> 
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                        <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                            {titolo}
                        </Col>
                    </Row>
                </Container>
                {sessionStorage.getItem('selectedRole') === 'Agenti' ?
                    <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                            <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", borderBottom: "1px solid #011e41", marginTop: "10px"}}>
                                <Button type="button" className="text-center" onClick={() => this.props.history.push('/cliente/add')} style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                    Aggiungi un nuovo cliente
                                </Button>                                    
                            </Col>
                        </Row> 
                    </Container> : null
                }       
                <Container className="d-flex align-items-center" fluid>
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px"}}>
                        <Col className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Clienti in Attesa</h4>
                        </Col>
                    </Row>
                </Container> 
                <Container className="d-flex align-items-center" fluid>
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", borderBottom: "1px solid #011e41"}}>
                        <Col className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <Table responsive borderless style={{margin: "0", marginTop: "5px"}}>
                                <thead>
                                    <tr>
                                        <th style={{padding: "0", width: "20%"}}>Codice Cliente</th>
                                        <th style={{padding: "0", width: "20%"}}>Ragione Sociale</th>
                                        <th style={{padding: "0", width: "20%"}}>Data inserita</th>
                                        <th style={{padding: "0", width: "40%"}}>Note</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.pendingClienti.map(cliente => {
                                        return(
                                            <tr key={cliente.codiceCliente}>
                                                <td align="left" style={{padding: "0"}}><a href={sessionStorage.getItem('selectedRole') === 'Amministrazione' ? `/cliente/approve/${cliente.codiceCliente}` : `../clienti/view/${cliente.codiceCliente}`}>{cliente.codiceCliente}</a></td>
                                                <td align="left" style={{padding: "0"}}>{cliente.ragSoc}</td>
                                                <td align="left" style={{padding: "0"}}>{new Date(cliente.dataInserisci).toLocaleDateString()}</td>
                                                <td align="left" style={{padding: "0"}}>{cliente.note}</td>
                                            </tr> 
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
                    {sessionStorage.getItem('selectedRole') === 'Agenti' ?
                        <div>
                            <Container className="d-flex align-items-center" fluid>
                                <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px"}}>
                                    <Col className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                                        <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Clienti Non Approvati</h4>
                                    </Col>
                                </Row>
                            </Container> 
                            <Container className="d-flex align-items-center" fluid>
                                <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px"}}>
                                    <Col className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                                        <Table responsive borderless style={{margin: "0", marginTop: "5px"}}>
                                            <thead>
                                                <tr>
                                                    <th style={{padding: "0", width: "20%"}}>Codice Cliente</th>
                                                    <th style={{padding: "0", width: "20%"}}>Ragione Sociale</th>
                                                    <th style={{padding: "0", width: "20%"}}>Data Non Approvata</th>
                                                    <th style={{padding: "0", width: "40%"}}>Note</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.nonApprovClienti.map(cliente => {
                                                    return(
                                                        <tr key={cliente.codiceCliente}>
                                                            <td align="left" style={{padding: "0"}}>
                                                                <Button type="submit" onClick={() => this.handleDelete(cliente.codiceCliente)} style={{width: "10%", padding: "0px", color: "#011e41", border: "none", backgroundColor: "transparent", marginLeft: "5px", marginRight: "10px"}}><i className="fa fa-trash" aria-hidden="true"></i></Button>
                                                                <a href={`../clienti/view/${cliente.codiceCliente}`}>{cliente.codiceCliente}</a>
                                                            </td>
                                                            <td align="left" style={{padding: "0"}}>{cliente.ragSoc}</td>
                                                            <td align="left" style={{padding: "0"}}>{new Date(cliente.dataApprovazione).toLocaleDateString()}</td>
                                                            <td align="left" style={{padding: "0"}}>{cliente.note}</td>
                                                        </tr> 
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </Container> 
                        </div> : null
                    }
            </Container> 
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/NuovoClienteMenu.js